/**
 * Description  :
 * Version      : 1.0.0
 * Author       : Luoye
 * Date         : 2022-08-12 09:56:46
 * LastEditors  : Luoye
 * FilePath     : /namibox_client_web/src/common/config/index.ts
 * Copyright (C) 2022 rose. All rights reserved.
 */
const hostDev = 'https://wweb.namibox.com';
const hostTest = 'https://wweb.namibox.com';
const host144 = 'https://150.namibox.com';
const hostPro = 'https://namibox.com';

let host = hostPro;

let _WENYANWEN_PRODUCT_ID = '10466';
let _GUSHI_PRODUCT_ID = '10465';

if (APP_ENV === 'development') {
  host = hostDev;
}
if (APP_ENV === 'test') {
  host = hostTest;
}
if (APP_ENV === 'development144') {
  host = host144;
  _GUSHI_PRODUCT_ID = '9951';
  _WENYANWEN_PRODUCT_ID = '9952';
}
if (APP_ENV === 'production') {
  _GUSHI_PRODUCT_ID = '9951';
  _WENYANWEN_PRODUCT_ID = '9952';
  host = hostPro;
}

export function handleReqURl(url: string, data?: object) {
  const reg = /https?:\/\//;
  if (!url || reg.test(url)) {
    return url;
  }
  let str = '';
  if (data) {
    let index = 0;
    for (const [key, value] of Object.entries(data)) {
      console.log(data, key);
      str += index === 0 ? `${key}=${value}` : `&${key}=${value}`;
      index += 1;
    }
  }
  if (str) {
    return /* APP_ENV === 'development' ? `${url}?${str}` :  */ `${host}${url}?${str}`;
  }
  return /* APP_ENV === 'development' ? url : */ `${host}${url}`;
}

let PAGE_HOST = '';
if (APP_ENV === 'test' || APP_ENV === 'development') {
  PAGE_HOST = 'https://m-test.namibox.com';
} else if (APP_ENV === 'development144') {
  PAGE_HOST = 'https://m-test.namibox.com/144';
} else if (APP_ENV === 'production') {
  PAGE_HOST = 'https://m.namibox.com';
}

export const WENYANWEN_PRODUCT_ID = _WENYANWEN_PRODUCT_ID;
export const GUSHI_PRODUCT_ID = _GUSHI_PRODUCT_ID;

export { host, PAGE_HOST };

export function getPageHost(name = '') {
  if (location.href.indexOf('x.namibox.com') > -1) {
    return `https://x.namibox.com/${name}.html`;
  }
  return `${PAGE_HOST}/${name}/`;
}
